import React from "react";

export const Panel = ({ className, variant, header, children, ...rest }) => (
  <div className={`panel ${className}`} {...rest}>
    {header && <div className={`panel-heading ${variant}`}>{header}</div>}
    <div className="panel-body">{children}</div>
  </div>
);
